// Global
import React from 'react';

export const HeroDecor = () => {
  return <></>;
};
